module.exports = __webpack_public_path__ + "static/media/219401245_DT2.6cd1a551.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/images/219401245_DT2.png
// module id = 490
// module chunks = 0